import type { IxcInventoryV1FirmOrderKeys } from '@interxfi/types/generated/api';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const INVENTORY_FIRM_ORDER_BASE_PATH = getResolvedPath('/clearing/operations/inventory/order');

export const getInventoryFirmOrderPath: EntityPathBuilder<IxcInventoryV1FirmOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INVENTORY_FIRM_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.firmOrderId) {
        return undefined;
      }

      return getResolvedPath(`${INVENTORY_FIRM_ORDER_BASE_PATH}/$firmOrderId`, { firmOrderId: context.keys.firmOrderId });
    }
  }
};

export function getInventoryFirmOrderDetailPath(firmOrderId: string | undefined) {
  if (!firmOrderId) {
    return undefined;
  }

  return getInventoryFirmOrderPath({ kind: 'detail', keys: { firmOrderId } });
}
